import { AttachmentsTab, FileType, GetPatientCasesParams, PatientSort, TreatmentPlanTask, TypeOfMessages } from 'types';

export const MAX_INPUT_LENGTH = 1240;
export const MAX_INPUT_LENGTH_2048 = 2048;
export const MAX_INPUT_ROWS = 6;

export const taskStatusMocked = [
  { name: 'New (unsubmitted)', id: 'TO_SUBMIT' },
  {
    name: 'Active (all submitted)',
    id: 'COMPLETED,DIAGNOSIS_SUBMITTED,DIAGNOSIS_TO_DO,IN_TREATMENT,LETTER_SENT,LETTER_SUBMITTED,LETTER_TO_DO,TREATMENT_PRE_FINISH,TREATMENT_POST_FINISH',
  },
  {
    name: 'In treatment',
    id: 'IN_TREATMENT,IN_TREATMENT',
  },
];

export const mapTaskStatusToText = {
  TO_SUBMIT: 'Submit patient case',
  DIAGNOSIS_TO_DO: 'Dx and tx required',
  DIAGNOSIS_SUBMITTED: 'Dx and tx submitted',
  LETTER_TO_DO: 'Letter review required',
  LETTER_SUBMITTED: 'Letter approved',
  LETTER_SENT: 'Letter sent',
  IN_TREATMENT: 'In Treatment',
  TREATMENT_PRE_FINISH: 'Pre-finish check',
  TREATMENT_POST_FINISH: 'Post-finish check',
  COMPLETED: 'Complete treatment',
  BLOCKED: 'Out of treatment',
  ARCHIVED: 'Archived',
};

export const messageAttachmentsRequestParams = {
  [AttachmentsTab.IMAGES]: {
    fileTypes: [FileType.BMP, FileType.JPEG, FileType.JPG, FileType.PNG, FileType.WEBP],
  },
  [AttachmentsTab.FILES]: {
    attachmentType: TypeOfMessages.FILE,
    fileTypes: [FileType.MP3, FileType.MP4, FileType.MPEG, FileType.PDF, FileType.OTHER],
  },
  [AttachmentsTab.LINKS]: {
    attachmentType: TypeOfMessages.LINK,
  },
};

export const patientSortLabel = {
  [PatientSort.lastName]: 'Last name A-Z',
  [PatientSort.idDesc]: 'ID descending',
  [PatientSort.idAsc]: 'ID ascending',
  mostRecent: 'Most recent',
};
